/*=============================
=            Sidebar          =
=============================*/

var sidebarItems = [].slice.call(document.querySelectorAll('.sidebar-links button'));

sidebarItems.forEach(function(sidebarItem) {
	sidebarItem.addEventListener('click', function() {
		var button = this,
			child = this.nextSibling,
			animation = window.getComputedStyle(child).display == 'block' ? 'slideUp' : 'slideDown';

		[].slice.call(this.parentNode.parentNode.querySelectorAll('.active:not(.closed) + ul, .open + ul')).forEach(function(open) {
			if(open != child && !open.contains(button)) {
				button = open.previousSibling;

				Velocity(open, 'slideUp', {duration: 150});

				if(button.classList.contains('active'))
					button.classList.add('closed');
				else
					button.classList.remove('open');

				open.setAttribute('aria-expanded', 'false');
			}
		});

		Velocity(child, animation, {duration: 150});

		this.classList.toggle(this.classList.contains('active') ? 'closed' : 'open');

		child.setAttribute('aria-expanded', (child.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));
	});
});